import React, { Component } from 'react'

const flags = (WrappedComponent, defaultState = {}) => {
  class Flags extends Component {
    constructor(props) {
      super(props)

      this.state = defaultState
    }

    reset = () => this.setState({})

    toggle = (flag) => this.setState(Object.assign(this.state, { [flag]: !this.state[flag] }))

    render = () =>
      <WrappedComponent
        { ...this.props }
        flags={ this.state }
        toggleFlagHandler={ this.toggle } />
  }

  WrappedComponent.type && (Flags.type = WrappedComponent.type)

  return Flags
}

export default flags
